<template>
  <div class="share-results">
    <div class="share-results__panel">
      <slot
        name="panel"
        :copy="copy"
        :openNewsletterModal="openNewsletterModal"
      />
    </div>

    <div
      class="share-results__status"
      role="status"
      v-text="statusMessage"
    />

    <slot
      name="modal"
      :close-newsletter-modal="closeNewsletterModal"
      :showNewsletterModal="showNewsletterModal"
    />
  </div>
</template>

<script>
  import { eventBus } from '@Foundation/eventbus/eventbus';
  import { mapActions } from 'vuex';
  import { types } from '@Feature/Quiz/code/Scripts/components/constants';

  const { INIT_RESULTS_PAGE, SEND_RESULTS } = types;

  export default {
    name: 'ShareResults',

    props: {
      answers: {
        type: Array,
        required: true,
      },
      apiUrl: {
        type: String,
        required: true,
      },
      statusTimeout: {
        default: 2000,
        type: Number,
      },
      successCopyMessage: {
        type: String,
        required: true,
      },
      urlToCopy: {
        type: String,
        required: true,
      },
    },

    data: () => ({
      showNewsletterModal: false,
      statusMessage: null,
    }),

    mounted() {
      this[INIT_RESULTS_PAGE]({
        config: {
          answers: this.answers,
          apiUrl: this.apiUrl,
          redirectAfterSendResults: false,
        },
      });

      eventBus.$on('skincare-newsletter', (newsletterData) => {
        this.closeNewsletterModal();
        this[SEND_RESULTS](newsletterData);
      });
    },

    methods: {
      ...mapActions('skincareV2Store', [
        INIT_RESULTS_PAGE, SEND_RESULTS,
      ]),

      closeNewsletterModal() {
        this.showNewsletterModal = false;
      },

      copy() {
        navigator.clipboard.writeText(this.urlToCopy).then(() => {
          this.statusMessage = this.successCopyMessage;

          setTimeout(() => {
            this.statusMessage = null;
          }, this.statusTimeout);
        });
      },

      openNewsletterModal() {
        this.showNewsletterModal = true;
      },
    },
  };
</script>
